import * as React from "react";
import ReactInputMask from "react-input-mask";
import { TextField } from "components/TextField";
import { TextFieldProps } from "components/TextField/TextField";
import { FieldWrapperProps } from "components/FieldWrapper/FieldWrapper";
export type PhoneEvent = {
  phone: string;
  formattedPhone: string;
  isValid: boolean;
};

interface Props {
  value: string;
  required?: boolean;
  onChangePhone: (event: PhoneEvent) => void;
  label?: string;
}

export const KG_PHONE_MAX_LENGTH = 13;

export const TextFieldPhone: React.FC<
  Props & TextFieldProps & FieldWrapperProps
> = ({
  value,
  required = true,
  onChangePhone,
  error,
  label,
  inputSize = "medium",
}) => {
  const onChangeText = (event: React.MouseEvent<HTMLInputElement>) => {
    const phone = event?.currentTarget.value;
    const formattedPhone = `+${phone.replace(/\D+/g, "")}`;
    const isValid = formattedPhone.length === KG_PHONE_MAX_LENGTH;
    onChangePhone({ phone, formattedPhone, isValid });
  };
  return (
    <ReactInputMask
      //@ts-ignore
      formatChars={{
        "1": "[0-9]",
        a: "[A-Za-z]",
        "*": "[A-Za-z0-9]",
      }}
      alwaysShowMask
      mask="+996111111111"
      value={value}
      //@ts-ignore
      onChange={onChangeText}
    >
      {(
        inputProps: JSX.IntrinsicAttributes &
          TextFieldProps &
          React.RefAttributes<HTMLInputElement>
      ) => (
        <TextField
          label={label || "Введите номер телефона"}
          required={required}
          {...inputProps}
          inputSize={inputSize}
          error={error}
          withError
        />
      )}
    </ReactInputMask>
  );
};
